export const appendUrlParam = (url: string, str: string): string => {
    if (url.indexOf('?') > 0) {
        return url + '&' + str
    }

    return url + '?' + str
}
